/**
 * NOTE: For compatibility across platforms all calls **must** return a
 * `Promise` object!
 */

import { PlatformMessage } from '@reachmedianetwork/post-message-client-rds-api';
import { PlayerPmc } from '../PlayerPmc';

export interface HeartbeatInterface {
    /**
     * **Feature:** Start sending the player software a heartBeat.
     *
     * Lets the Player Software know that the application is running and hasn't
     * crashed.
     */
    startSendingHeartbeat(): Promise<void>;
}

export function supportsHeartbeat(platform: unknown): platform is HeartbeatInterface {
    if (platform instanceof PlayerPmc) {
        return (
            platform.supportsMessage(PlatformMessage.HeartbeatEnable) &&
            platform.supportsMessage(PlatformMessage.HeartbeatPing)
        );
    }

    return platform instanceof Object && 'startSendingHeartbeat' in platform;
}
